import { GET_POPULAR_STOPS, ADD_REST_STOPS, SEARCH_CITY_PLACES } from "../../config/urls";
import {
  deleteCall,
  genericDeleteCall,
  mmiKeyGetCall,
  genericPostCall,
  getCall,
  placesPostCall,
  postCall,
} from "../../utils/apiCalls";
import { opdbGTM } from "../../utils/pulseUtils";
import {
  POPULAR_STOPS,
  PLACE_SEARCH_RESULTS,
  MMI_KEY,
  ADD_REST_STOP,
  DELETE_STOP,
  GET_DISTANCE,
} from "./actionTypes";

export const fetchPopularStops = (query) => (dispatch) => {
  getCall(GET_POPULAR_STOPS, query).then((res) => {
    if (!res.data || !res.data.rest_stops.length) return;
    dispatch({
      type: POPULAR_STOPS,
      payload: res.data.rest_stops || [],
    });
  });
};

export const getMMIKey = () => (dispatch) => {
  let url =
    "https://travel.paytm.com/bus-gps/v1/signature?isH5=true&isPrimary=true";
  mmiKeyGetCall(url, "").then((res) => {
    if (!res.data) return;
    dispatch({
      type: MMI_KEY,
      payload: res.data.body.access_token || [],
    });
  });
};

export const getPickupPoints = (point) => (dispatch) => {
  let url = SEARCH_CITY_PLACES;
  // let url = "https://travel.paytm.com/bus-gps/v1/location/search";
  let data = {
    data: point,
  };
  placesPostCall(url, data)
    .then((res) => {
      if (res && res.status === 200) {
        dispatch({
          type: PLACE_SEARCH_RESULTS,
          payload: { data: res.data.body || [] },
        });
      } else {
        const err =
          (res.response.data || {}).message || "Error, Please try again.";
        alert(err);
      }
    })
    .catch((error) => {
      const err =
          (error && error.response && error.response.data && error.response.data.message) ||
          "Couldn't fetch the search results. Please try again.";
        alert(err);
    });
};

export const assignRestStops = (payload) => (dispatch) => {
  const url = ADD_REST_STOPS;
  postCall(url, payload).then((res) => {
    if (res && res.status === 200) {
      dispatch({
        type: ADD_REST_STOP,
        payload: { data: res.data || [] },
      });
      const source = JSON.parse(localStorage.getItem('source'))
      const destination = JSON.parse(localStorage.getItem('destination'))
      opdbGTM.restStopsAdded(source.city_name || source.name, destination.city_name || destination.name );
      alert("Rest stop(s) added successfully.");
    } else {
      const err =
        (res.response.data || {}).message || "Error, Please try again.";
      alert(err);
    }
  });
};

export const deleteRestStop = (data) => (dispatch) => {
  const url = ADD_REST_STOPS;
  genericDeleteCall(url, data).then((res) => {
    if (res.status === 200) {
      dispatch({
        type: DELETE_STOP,
        payload: { data: res.data || [] },
      });
      alert("Rest stop deleted successfully...");
      // window.location.reload();
    } else {
      alert(
        res.response.data.message || "Something went wrong, please try later."
      );
    }
  });
};
